// extracted by mini-css-extract-plugin
module.exports = {"InputSelect":"styles_InputSelect__2jtI8","InputSelectLabel":"styles_InputSelectLabel__1-K2T"};